// @flow
import type { OptionType } from '../types'
import _ from 'lodash'
import { Audience } from '../constants'

const t = {
  fixed: 'Фиксированная ставка',
  max_amount: 'Максимальное число',
  min_cost: 'Минимальный расход',
  clicks: 'переходов',
  shows: 'показов'
}

export default function biddingModeOptions(
  provider: string,
  paymentType: string
): Array<OptionType> {
  const maxAmountOption = {
    id: 'max_amount',
    name: `${t.max_amount} ${paymentType === Audience.payment_types.cpc ? t.clicks : t.shows}`
  }
  const minCostOption = { id: 'min_cost', name: t.min_cost }
  const fixedOption = { id: 'fixed', name: t.fixed }
  switch (provider) {
    case 'vk':
      return _.includes([Audience.payment_types.cpc, Audience.payment_types.cpm], paymentType)
        ? [fixedOption, maxAmountOption]
        : []
    case 'target_mail':
      return _.includes([Audience.payment_types.cpc, Audience.payment_types.cpm], paymentType)
        ? [maxAmountOption, minCostOption, fixedOption]
        : []
    case 'facebook':
      return paymentType === Audience.payment_types.cpc ? [maxAmountOption, minCostOption] : []
    default:
      return []
  }
}
